<h1 mat-dialog-title>{{'Select Story'|translate}}</h1>
<div mat-dialog-content #dialogContent>
  <app-story-catalog-view *ngFor="let story of stories" [story]="story" (click)="selectStory(story)"></app-story-catalog-view>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="cancel()">{{'Cancel'|translate}}</button>
</div>
